export default __webpack_public_path__ + "static/media/1936.91be39a8.png";